import { createApi } from '@reduxjs/toolkit/query/react';
import { newBackendAxiosBaseQuery } from '../../utils/axiosBaseQuery';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

// Check-in / check-out timestamps for an order in the generic (venue/apartment)
// check-in/checkout flow. Recorded by the end-user app on the operational
// `usage_log` row and surfaced by the new-backend admin endpoint
// `GET /admin/order/:orderId/usage-log`. Null when the order has no usage_log
// yet (customer never checked in).
export interface OrderUsageLogReturnPhoto {
    /** Short-lived presigned GET URL; null when the photo was skipped/failed. */
    url: string | null;
    /** 'uploaded' | 'skipped' | 'failed' | null. */
    status: string | null;
    uploadedAt: string | null;
}

export interface OrderUsageLogResponse {
    orderId: string;
    activatedAt: string | null;
    finishedAt: string | null;
    participantCount: number | null;
    /** Check-out photo. null when the order has none (or no usage_log). */
    returnPhoto: OrderUsageLogReturnPhoto | null;
}

export const orderUsageLogApiSlice = createApi({
    reducerPath: 'orderUsageLogApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: newBackendAxiosBaseQuery(),
    tagTypes: ['OrderUsageLog'],
    endpoints: (builder) => ({
        getOrderUsageLog: builder.query<OrderUsageLogResponse, { orderId: string }>({
            query: ({ orderId }) => ({
                url: `/order/${orderId}/usage-log`,
                method: 'GET',
            }),
            providesTags: (_result, _error, { orderId }) => [
                { type: 'OrderUsageLog', id: orderId },
            ],
        }),
    }),
});

export const { useGetOrderUsageLogQuery } = orderUsageLogApiSlice;
